<template>
    <div>
        <SimpleDataTable
            :table-title="getTabTitle"
            :headers="headers"
            :items="data"
            :hide-pager="hidePager"
            :keep-desktop-layout="keepDesktopLayout"
        >
            <template v-slot:title-prepend>
                <v-btn @click="prevTab"
                       :disabled="currentTab === 1 || !headers.length"
                       color="primary" icon small>
                    <v-icon>mdi-menu-left</v-icon>
                </v-btn>
            </template>
            <template v-slot:title-append>
                <v-btn @click="nextTab"
                       :disabled="currentTab === totalTab || !headers.length"
                       color="primary" icon small>
                    <v-icon>mdi-menu-right</v-icon>
                </v-btn>
            </template>
            <template v-slot:conversation_flow="props">
                <div class="row-actions centerXY">
                    <span class="row-actions">
                        <v-tooltip v-if="props.item.$conversation_flow && props.item.$conversation_flow.length > 0" top>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    v-on="on"
                                    size="18"
                                    class="action-icon"
                                    @click.stop="openConversationFlow(props.item)"
                                >mdi-history</v-icon>
                            </template>
                            <span>{{ $f.tc('details') }}</span>
                        </v-tooltip>
                    </span>
                </div>
            </template>
        </SimpleDataTable>
        <div v-if="!headers.length" class="text-xs-center" style="font-size: 14px !important;">
            <br><br>{{ $f.tc('noDataAvailable') }}<br><br>
        </div>
        <CampaignConversationFlow
            ref="CampaignConversationFlow"
        ></CampaignConversationFlow>
    </div>
</template>
<script>
import SimpleDataTable from '@/components/SimpleDataTable'
import CampaignConversationFlow from "@/views/Campaign/Form/Step3/CampaignConversationFlow.vue";

const DEFAULT_NODE = {
    "card_list" : [],
    "id": "",
    "name": "",
    "nlp_config": {},
    "slug": "",
    "setting": null,
    "type": ""
}

export default {
    name: 'DataTableWithTabNav',
    components: {CampaignConversationFlow, SimpleDataTable},
    props: {
        tabTitle: {
            type: String,
            required: true
        },
        dataTable: {
            type: Array,
            default: () => [],
            required: true
        },
        dataHeaders: {
            type: Array,
            default: () => [],
            required: true
        },
        columnsPerTab: {
            type: Number,
            default: 3,
            required: true
        },
        defaultTab: {
            type: Number,
            default: 1
        },
        hidePager: {
            type: Boolean,
            default: () => false
        },
        keepDesktopLayout: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            data: this.dataTable,
            headers: this.dataHeaders,
            currentTab: null
        }
    },
    created() {
        this.currentTab = this.defaultTab || 1
        this.setTab(this.currentTab)
    },
    computed: {
        getTabTitle() {
            if (this.dataHeaders.length) {
                return this.tabTitle + ' (' + this.currentTab + '/' + this.totalTab + ')'
            } else {
                return this.tabTitle + ' (0/0)'
            }
        },
        totalTab() {
            if (this.headers.length) {
                return Math.ceil(this.headers.length / this.columnsPerTab)
            } else {
                return 0
            }
        }
    },
    methods: {
        setTab(tab) {
            let end = (tab * this.columnsPerTab) - 1
            let start = end - (this.columnsPerTab - 1)
            this.headers = this.headers.map((column, index) => {
                column.invisible = !(index >= start && index <= end);
                return column
            })
        },
        prevTab() {
            this.currentTab -= 1
            this.setTab(this.currentTab)
        },
        nextTab() {
            this.currentTab += 1
            this.setTab(this.currentTab)
        },
        openConversationFlow(item) {
            this.convertToCallHistoryLogs(item.$conversation_flow)
            this.$refs.CampaignConversationFlow.open()
        },
        convertToCallHistoryLogs(item) {
            let stepsArray = item.split('->')
            let callHistoryLog = []
            let startNode = this.$utils.cloneObject(DEFAULT_NODE)
            startNode.name = 'Start'
            startNode.type = 'DEBUG'
            callHistoryLog.push({
                "node": startNode,
                "input": {},
                "output": {},
                "latency": 0,
                "cardLogs": [],
                "transferCallNumber": "",
                "message": "",
            })
            stepsArray.forEach(step => {
                let newNode = this.$utils.cloneObject(DEFAULT_NODE)
                newNode.name = step.split(':')[1]
                switch (step.split(':')[0]) {
                    case 'Transfer':
                        newNode.type = 'SUPPORTER'
                        break
                    case 'Client':
                        newNode.type = 'DECISION'
                        break
                    default:
                        newNode.type = 'PROCESS'
                }
                callHistoryLog.push({
                    "node": newNode,
                    "input": {},
                    "output": {},
                    "latency": 0,
                    "cardLogs": [],
                    "transferCallNumber": "",
                    "message": "",
                })
            })
            let endNode = this.$utils.cloneObject(DEFAULT_NODE)
            endNode.name = 'End'
            endNode.type = 'DEBUG'
            callHistoryLog.push({
                "node": endNode,
                "input": {},
                "output": {},
                "latency": 0,
                "cardLogs": [],
                "transferCallNumber": "",
                "message": "",
            })
            callHistoryLog.forEach((i, idx) => i.index = idx)
            this.$store.commit(this.$actionTypes.scenario.SCENARIO_SETTING, {'version': 1})
            this.$store.dispatch(this.$actionTypes.debug.UPDATE_DATA_FLOW, {
                nodeList: callHistoryLog,
            })
        }
    },
    watch: {
        dataTable() {
            this.data = this.dataTable
        }
        // dataHeaders() {
        //     this.headers    = this.dataHeaders
        //     this.currentTab = 1
        //     this.setTab(this.currentTab)
        // }
    }
}
</script>
